import React, { Component } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faComment } from "@fortawesome/free-solid-svg-icons";
import { faComment } from "@fortawesome/free-regular-svg-icons";
import { renderErrorMessage } from "../../helper/user_helper";
import { postCommentRecommendaton } from "../../helper/comment_helper";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

import { setUserLocalStorage } from "../../helper/user_helper";

import $ from "jquery";
import ShareButton from "../share/share_button";
import CommentRecommendation from "./comment_recommendation";
import LikeRecommendation from "./like_recommendation";
import BookmarkRecommendation from "../bookmark/bookmark_recommendation";
import RecommendationLink from "./recommendation_interface/recommendation_link";

let strings = new LocalizedStrings({ en });

class UserRecommendationComment extends Component {
  state = {
    comments: "",
    errors: "",
    user: null,
    signedIn: false,
    showAll: false
  };

  componentDidMount() {
    if (setUserLocalStorage().signedIn === true) {
      const userLocalStorage = setUserLocalStorage();
      const user = userLocalStorage.user;
      const signedIn = userLocalStorage.signedIn;
      this.setState({ user, signedIn });
    }
  }

  componentWillUnmount() {
    if (this.postCommentCall) {
      this.postCommentCall.cancel();
    }
  }

  componentDidUpdate() {}
  render() {
    // if (this.state.user === null) {
    //   // If user not login we don't let user ability to post
    //   return <div />;
    // }

    return (
      <div className="row  pb-3 mr-1 user_recommendation_comment_row">
        <div className="width_100">{renderErrorMessage(this.state.errors)}</div>
        <div className="row width_100">
          {/* <div style={{ width: "calc(80% - 50px)" }} /> */}
          <div className="width_image_question cursor_btn width_recommendation_buttons">
            <LikeRecommendation
              recommendation={this.props.recommendation}
              handlerLikeRecommendation={this.props.handlerLikeRecommendation}
              history={this.props.history}
            />
          </div>
          <div
            className="width_image_question cursor_btn width_recommendation_buttons"
            onClick={this.showFullPageComments}
          >
            <div className="comment_number_icon">
              <FontAwesomeIcon
                className="comment"
                icon={faComment}
                mask={["far", "circle"]}
              />
            </div>
            {/* <div className="comment_number">...</div> */}
          </div>

          <div className="width_image_question cursor_btn width_recommendation_buttons">
            <ShareButton
              url={"recommendations/" + this.props.recommendation.id}
            />
          </div>

          <div className="width_image_question width_recommendation_spacing_buttons" />
          <div className="width_image_question cursor_btn width_recommendation_buttons">
            <BookmarkRecommendation
              recommendation={this.props.recommendation}
              history={this.props.history}
            />
          </div>
        </div>
        <div
          className="width_text_question recommendation_comment "
          style={{ width: "100%" }}
        >
          <div className="show_more">{this.renderComments()}</div>
        </div>
      </div>
    );
  }

  renderComments() {
    var number_character_max = 100;
    if ($(document).width() < 500) {
      number_character_max = 80;
    }
    if ($(document).width() < 400) {
      number_character_max = 75;
    }
    if ($(document).width() < 350) {
      number_character_max = 60;
    }
    if (
      (this.props.recommendation.name.length > number_character_max &&
        this.state.showAll === false) ||
      (this.props.recommendation.url !== "" && this.state.showAll === false)
    ) {
      return (
        <label className="more">
          <span>@{this.props.recommendation.user.username} </span>
          <CommentRecommendation
            comment={this.props.recommendation.name.substring(
              0,
              number_character_max
            )}
          />
          <span onClick={this.handlerShowAll} className="cursor_btn">
            ...
          </span>
        </label>
      );
    }
    return (
      <label className="more">
        <span>@{this.props.recommendation.user.username} </span>
        <CommentRecommendation comment={this.props.recommendation.name} />
        <RecommendationLink recommendation={this.props.recommendation} />
      </label>
    );
  }

  showFullPageComments = e => {
    this.props.showFullPageComments(this.props.recommendation);
  };

  handleChangeComments = event => {
    this.setState({ comments: event.target.value });
  };

  handlerShowAll = event => {
    event.preventDefault();
    this.setState({ showAll: true });
  };

  sendComments = e => {
    if (this.state.comments.length === 0) {
      this.setState({ errors: strings.comments_too_short });
      return;
    }
    this.setState({ loaded: false, errors: "" });
    var fd = new FormData();
    fd.append("comment[name]", this.state.comments);

    const self = this;
    this.postCommentCall = postCommentRecommendaton(
      this.props.recommendation.id,
      fd
    );
    this.postCommentCall.promise
      .then(answer => {
        self.props.updateCommentsNumber(self.props.recommendation);
        self.setState({ loaded: true, comments: "" });
      })
      .catch(error => {
        self.setState({ loaded: true, errors: error.errors });
      });
  };
}

export default UserRecommendationComment;



// WEBPACK FOOTER //
// ./src/components/recommendation/user_recommendation_comment.jsx